import styled from "styled-components";

export const InteractionsModule = styled.div`
	width: 50%;
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
`;
